export var euiAnimSlightBounce = "cubic-bezier(0.34, 1.61, 0.7, 1)"
export var euiAnimSlightResistance = "cubic-bezier(0.694, 0.0482, 0.335, 1)"
export var euiAnimSpeedExtraFast = 90
export var euiAnimSpeedFast = 150
export var euiAnimSpeedNormal = 250
export var euiAnimSpeedSlow = 350
export var euiAnimSpeedExtraSlow = 500
export default {"euiAnimSlightBounce":"cubic-bezier(0.34, 1.61, 0.7, 1)","euiAnimSlightResistance":"cubic-bezier(0.694, 0.0482, 0.335, 1)","euiAnimSpeedExtraFast":90,"euiAnimSpeedFast":150,"euiAnimSpeedNormal":250,"euiAnimSpeedSlow":350,"euiAnimSpeedExtraSlow":500}
